import { SharedService } from './../../../layouts/shared-service';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

// Services
import { AircraftsService } from '../../../services/aircrafts.service';
import { CustomeraircraftsService } from '../../../services/customeraircrafts.service';
import { DialogConfirmAircraftDeleteComponent } from '../customer-aircrafts-confirm-delete-modal/customer-aircrafts-confirm-delete-modal.component';
import { AppDialogWrapperService } from '../../../ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

import { CustomerAircraftNote } from '../../../models/customer-aircraft-note';
import { CustomerAircraft } from '../../../models/customer-aircraft';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomerAircraftAddedFrom } from '../../../enums/customer-aircraft-added-from.enum';

@Component({
    selector: 'app-customer-aircrafts-edit',
    styleUrls: ['./customer-aircrafts-edit.component.scss'],
    templateUrl: './customer-aircrafts-edit.component.html',
})
export class CustomerAircraftsEditComponent implements OnInit {
    @Output() saveEditClicked = new EventEmitter<any>();
    @Output() cancelEditClicked = new EventEmitter<any>();
    @Input() customerAircraftInfo: CustomerAircraft;

    // Public Members
    public chartName = 'CustomerAircrafts';
    public aircraftSizes: Array<any>;
    public aircraftTypes: Array<any>;
    public pricingTemplates: Array<any>;
    public customerInfoByGroupId : any ;
    public customerAircraftNote: CustomerAircraftNote;
    private loadedNoteText = '';

    get isDeleteDisabled(): boolean {
        // Check if delete is disabled from passed data flag
        if (this.data && this.data.disableDelete) {
            return true;
        }
        
        // Check if aircraft is from Fuelerlinx and was synced from Fuelerlinx
        if (this.customerAircraftInfo) {
            const aircraftInfo = this.customerAircraftInfo as any;
            if (aircraftInfo.isFuelerlinxNetwork && 
                aircraftInfo.addedFrom === CustomerAircraftAddedFrom.Fuelerlinx) {
                return true;
            }
        }
        
        return false;
    }

    // For AppDialogWrapperService pattern
    data: any;
    dialogRef: { close: (result?: any) => void };

    constructor(
        private aircraftsService: AircraftsService,
        private customerAircraftsService: CustomeraircraftsService,
        private appDialogWrapperService: AppDialogWrapperService,
        private sharedService : SharedService,
        private ngxLoader: NgxUiLoaderService,
    ) {}

    async ngOnInit() {
        this.ngxLoader.startLoader(this.chartName);

        this.aircraftTypes = await this.aircraftsService
            .getAll().toPromise();

        this.aircraftSizes = await this.aircraftsService
            .getAircraftSizes().toPromise();

        this.customerAircraftInfo = await this.customerAircraftsService.get(this.data).toPromise();
        // Each note is a log entry shared with the redesign; legacy shows and edits the newest one.
        var newestFirst = [...(this.customerAircraftInfo?.notes ?? [])]
            .sort((a, b) => new Date(b.lastUpdatedUtc ?? 0).getTime() - new Date(a.lastUpdatedUtc ?? 0).getTime() || b.oid - a.oid);
        this.customerAircraftNote = newestFirst.length > 0 ? newestFirst[0] : null;
        if (this.customerAircraftNote == null)
            this.customerAircraftNote = {
                oid: 0,
                fboId: this.sharedService.currentUser.fboId,
                customerAircraftId: this.customerAircraftInfo.oid,
                notes: '',
                lastUpdatedByUserId: this.sharedService.currentUser.oid
            };
        this.loadedNoteText = this.customerAircraftNote.notes ?? '';

        this.ngxLoader.stopLoader(this.chartName);
    }

    public async saveEdit() {
        this.ngxLoader.startLoader(this.chartName);

        let data = await this.customerAircraftsService
            .update(this.customerAircraftInfo , this.sharedService.currentUser.oid).toPromise();

        this.customerAircraftNote.customerAircraftId = data.oid;
        // The note box shows the newest entry of a log shared with the redesign, possibly another
        // user's or FBO's. Legacy never rewrites or deletes an entry: changed text is logged as a new
        // entry by this user, and an unchanged or cleared box leaves the log alone.
        var noteText = (this.customerAircraftNote.notes ?? '').trim();
        if (noteText === '' || noteText === this.loadedNoteText.trim()) {
            this.dialogRef.close(data);
        } else {
            var newEntry: CustomerAircraftNote = {
                oid: 0,
                customerAircraftId: data.oid,
                fboId: this.sharedService.currentUser.fboId,
                notes: noteText,
                lastUpdatedByUserId: this.sharedService.currentUser.oid
            };
            this.customerAircraftsService.addCustomerAircraftNotes(newEntry).subscribe((noteResponse: any) => { this.dialogRef.close(data); })
        }
        this.ngxLoader.stopLoader(this.chartName);
    }

    public cancelEdit() {
        this.data = null;
        this.dialogRef.close();
    }

    public ConfirmDelete(data: any) {
        const dialogWrapper = this.appDialogWrapperService.open<any>({
            title: 'Delete Aircraft',
            component: DialogConfirmAircraftDeleteComponent,
            data: data,
            width: '450px'
        });

        dialogWrapper.afterClosed().subscribe((result) => {
            if (result === 'cancel') {
            } else if (result && result.oid) {
                result.toDelete = true;
                this.dialogRef.close(result);
            }
        });
    }
}
